<!-- =========================================================================================
  File Name: DataListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <password-view-sidebar :isSidebarActive="addPasswordSidebar" @closeSidebar="togglePassswordSidebar" :data="passwordSidebarData" />
    <!-- ADD NEW -->
    <div >
      <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
    <vs-button class="user_add_btn" type="filled" @click="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Manager</vs-button>
    </div>
    <vs-table ref="table" :data="filteredManagerList" :max-items="itemsPerPage"  pagination
              search>

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="selected.length>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions ({{selected.length}})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

           <vs-dropdown-menu>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="selectAction('status')">
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Enable</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="selectAction('disablestatus')">
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Disabled</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span class="flex items-center" @click="selectAction('deleteuser')">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

<!--           FILTER-->
         <vx-tooltip v-if="locations.length>0" text="Search By Location" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">Search By Location</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location')">
                <span class="flex items-center">
                  <span  >All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span >{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
              <vx-tooltip text="Search By Status" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter_status">Search By Status</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="statusSelected('Search By Status')">
                <span class="flex items-center">
                  <span>All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="status in statuses" :key="status.id" @click="statusSelected(status.name)">
                <span class="flex items-center">
                  <span >{{ status.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>
          <!-- ADD NEW -->
<!--          <div-->
<!--            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"-->
<!--            @click="addNewData">-->
<!--            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>-->
<!--            <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ managers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : managers.length }} of {{
                queriedManager
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th sort-key="name">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="locations">Locations</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <!-- <vs-th sort-key="status">Email Confirmed</vs-th> -->
        <vs-th sort-key="status">Status</vs-th>

        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]"></vs-checkbox></vs-td>
              <vs-td class="img-container">
                <img v-if="tr.avatar"  :src="img_cdn + tr.avatar"   class="rounded-full shadow-md user-img" />
                <p v-else class="bg-primary image-not-found text-white" :data-letterstudent=tr.fname[0].toUpperCase()></p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.fname }}  {{ tr.lname }}</p>
                <p class="product-category"><a :href="`tel:${tr.phone}`" @click.stop="">{{ tr.phone }}</a></p>

              </vs-td>


              <vs-td>
              <ul><li v-for="location in tr.managerlocations" style="display: flex" :key="location.id"><vs-chip >{{ location.name }}</vs-chip></li></ul>

              </vs-td>

              <vs-td>
                <p class="product-category" ><a :href="`mailto:${tr.email}`" @click.stop="">{{ tr.email }}</a></p>
              </vs-td>

              <!-- <vs-td>
                <vs-switch  v-model="tr.email_confirmed" @input="updateEmailStatus(tr.id,tr.email_confirmed)"></vs-switch>
              </vs-td> -->

              <vs-td>
                <vs-switch v-model="tr.status"  @input="updateStatus(tr.id,tr.status)"></vs-switch>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                </div>
                 <vs-dropdown-menu>
                 <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item>
                <span class="flex items-center" @click="passwordData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Password Reset</span>
                </span>
                  </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
                <!--                <feather-icon icon="EditIcon" svgClasses="w-6 h-6 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
                <!--                <feather-icon icon="TrashIcon" svgClasses="w-6 h-6 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import vSelect from 'vue-select'
import PasswordViewSidebar from './PasswordViewSidebar'
import {
  ADMIN_USERS_LIST,
  ALL_LOCATIONS,
  ALL_MANAGERS_QUERY,
  REMOVE_MANAGER,
  UPDATE_MANAGER_EMAIL_STATUS,
  UPDATE_MANAGER_STATUS,
  UPDATE_USER_STATUS
} from "@/graphql";


export default {
  components: {
    DataViewSidebar,
    'v-select': vSelect,
    'PasswordViewSidebar' : PasswordViewSidebar,

  },
  data () {
    return {
      img_cdn:'',
      headCheckbox:'',
      selectedCheck:[],
      managers:[],
      locations:[],
      custom_search_filter:'Search By Location',
      custom_search_filter_status:'Search By Status',
      statuses:[
        {
          id:'1',
          name:'Active'
        },
        {
          id:'2',
          name:'Disabled'
        },
        {
          id:'3',
          name:'Pending'
        }
      ],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      addPasswordSidebar:false,
      sidebarData: {},
      passwordSidebarData:{},
      DeletedItem:'',
    }
  },
  computed: {

    filteredManagerList: function () {
      var custom_search_filter_status = this.custom_search_filter_status
      var custom_search_filter = this.custom_search_filter
      return this.managers.filter(function(manager) {
        if( custom_search_filter_status != 'Search By Status' && custom_search_filter == 'Search By Location')
        {
         if(custom_search_filter_status=="Active"){
              if(manager.email_confirmed && manager.status){
                return true
              }
            return false
         }
          if(custom_search_filter_status=="Disabled"){
             if(manager.email_confirmed==false && manager.status==false){
                return true
              }
            return false
          }
          if(custom_search_filter_status=="Pending"){
             if(manager.email_confirmed==false && manager.status==true){
                return true
              }
            return false
          }
        }
        if (custom_search_filter == 'Search By Location') {
         return true;
        }
        if(custom_search_filter !== 'Search By Location'){
         for (var i=0 ;i<manager.managerlocations.length; i++) {
            if(manager.managerlocations[i].name == custom_search_filter){
              return true;
            }
          }
          return false
        }
        return true;
      });
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.managers.length
    },
    queriedManager() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.managers.length
    }
  },
  methods: {
    ConfirmNotification(status) {
      this.$vs.notify({
        title: "Manager",
        text: 'Manager '+status+' Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusSuccess(status,color) {
      this.$vs.notify({
        title: "Manager",
        text: status,
        color: color,
        position: 'top-right'
      })},
selectAction(action){
if(this.selected.length>0){
     this.$apollo
              .mutate({
                mutation: USER_EMAIL_CONFIRMED,
                variables: {
                  name: action,
                  user_ids: this.selected,
                }
              }).then(response => {
              if(response){
                this.ConfirmNotification(response.data.confirmUserEmail.status)
                this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                this.getManagerList();
              }
            }).catch(error => {

            });
}
},
    CheckAll(){
    var selected=[]
    if(this.headCheckbox){
    for (let index = 0; index < this.managers.length; index++) {
                 this.selectedCheck[index]=true;
                 selected.push(this.managers[index].id)
                 }
        this.selected=selected
    }
    else{
      for (let index = 0; index < this.managers.length; index++) {
                 this.selectedCheck[index]=false;
                 }
        this.selected=[]
    }
  },
   SelectItem(id){
    if(!this.headCheckbox){
    var status=false
    for (var i = 0; i < this.selected.length; i++) {
    if (this.selected[i] == id) {
       status=true
    }
  }
  if(status){
  this.selected.pop(id)
  }
  else{
      this.selected.push(id)
  }
}
else{
    const index = this.selected.indexOf(id);
   if (index > -1) {
     this.selected.splice(index, 1);
  }
  else{
     this.selected.push(id)
  }
}
},
    getManagerList() {
      this.$apollo
        .mutate({
          mutation: ALL_MANAGERS_QUERY,
        })
        .then(response => {
          this.managers = response.data.getManagersList.users
          this.getLocationsList()
        })
    },
    getLocationsList() {
      this.$apollo
        .mutate({
          mutation: ALL_LOCATIONS,
        })
        .then(response => {
          this.locations = response.data.locations
        })
    },
    setSelected(value) {
      this.custom_search_filter = value;
    },
    statusSelected(value) {
      this.custom_search_filter_status = value;
    },

    updateStatus(id, status) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_STATUS,
          variables: {
            id :id,
            status: status,
          }
        }).then(response => {
        if(response){
          this.$vs.notify({
            title: 'Manager',
            text: 'Status Updated Sucessfully',
            color: 'success',
            position: 'top-right'
          })

        }
      })
    },
    updateEmailStatus(id,email_confirmed) {
      this.$apollo
        .mutate({
          mutation: UPDATE_MANAGER_EMAIL_STATUS,
          variables: {
            id :id,
            email_confirmed: email_confirmed,
          }
        }).then(response => {
        if(response){
          this.$vs.notify({
            title: 'Email Status',
            text: 'Updated Sucessfully',
            color: 'success',
            position: 'top-right'
          })
        }
      })
    },
    togglePassswordSidebar (val = false) {
    this.addPasswordSidebar = val
      if(!val) {
        this.getManagerList()
      }
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)

    },
    confirmDeleteRecord (manager) {
      this.DeletedItem=manager
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${manager.fname} ${manager.lname}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData() {
      this.$apollo
        .mutate({
          mutation: REMOVE_MANAGER,
          variables: {
            id: this.DeletedItem.id,
          },
        }).then(response => {
          this.getManagerList()
          if(response.data.deleteManager.status=='Success'){
            this.StatusSuccess(response.data.deleteManager.message,response.data.deleteManager.color)
          }
          else{
            this.StatusSuccess(response.data.deleteManager.message,response.data.deleteManager.color)
          }
        }).catch(error => {
         console.log(error)
      });
      // this.$store.dispatch('dataList/removeManager', id).catch(err => {
      //   console.error(err)
      // })
    },
    editData(data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    passwordData (data) {
      this.passwordSidebarData = data
      this.togglePassswordSidebar(true)
    },
    getStatusText (status) {
      if (status === 'on_hold')   return 'Pending'
      if (status === 'delivered') return 'Active'
      if (status === 'canceled')  return 'Disabled'
      return 'primary'
    },
    getOrderStatusColor (status) {
      if (status === 'on_hold')   return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled')  return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90)  return 'success'
      if (num > 70)  return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50)  return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if(!val) {
        this.getManagerList()
      }
    }
  },
  created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
 this.getManagerList()

  },
  mounted () {
    this.isMounted = true
  },

}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
    .user-img {
      height: 50px;
      border-radius: 50%;
    }
  [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .image-not-found{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  }
  }
}
</style>
